<template #default>
  <div class="swap-modal">
    <a-modal
      class="page-modal"
      v-model:visible="modalVisible"
      :title="isEdit ? 'Edit ' + localForm.assetClass : 'Add Swap'"
      :style="{ top: '32px', width: '1500px' }"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="loading"
      destroyOnClose
    >
      <a-form
        ref="addFormRef"
        :model="localForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="rules"
      >
        <a-row :gutter="24">
          <a-card
            class="swap-card"
            title="Underlying Details"
            :bordered="false"
          >
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item
                  label="Ticker"
                  name="underlyingTicker"
                  :labelCol="{ span: 3, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 21 }"
                >
                  <a-auto-complete
                    v-model:value="localForm.underlyingTicker"
                    :disabled="isEdit"
                    :options="underlyingOptions"
                    @search="onSearchUnderlying"
                    @select="onSelectUnderlying"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Exchange"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-select
                    v-model:value="localForm.underlying.exchange.exchangeId"
                    disabled
                  >
                    <a-select-option
                      v-for="item in exchangeList"
                      :key="item.exchName"
                      :value="item.exchangeId"
                    >
                      {{ item.exchName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Issue Ccy"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input
                    :value="localForm.underlying?.issuer?.issueCurrency || ''"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Ratio(Swap/Uly)"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-input-number
                    v-model:value="localForm.conversionRatio"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24"> </a-row>
          </a-card>
        </a-row>
        <a-row :gutter="24">
          <a-card
            class="swap-card"
            title="Instrument Details"
            :bordered="false"
          >
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Issuer"
                  name="issuer"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.issuer.issuerId"
                    @change="onIssuerChange"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in issuerList"
                      :key="item.name"
                      :value="item.issuerId"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Exchange"
                  name="exchange"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.exchange.exchangeId"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in exchangeList"
                      :key="item.exchName"
                      :value="item.exchangeId"
                    >
                      {{ item.exchName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Status"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.isActive"
                    style="width: 100%"
                  >
                    <a-select-option :value="true">ACTIVE</a-select-option>
                    <a-select-option :value="false">INACTIVE</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="4">
                <a-form-item
                  label="Inst Class"
                  name="instrumentClass"
                  :labelCol="{ span: 9, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 15 }"
                >
                  <a-select
                    v-model:value="localForm.instrumentClass"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    :disabled="isEdit"
                  >
                    <a-select-option
                      v-for="item in swapInstClassList"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="10">
                <a-form-item
                  label="Name"
                  name="desc"
                  :labelCol="{ span: 3, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 21 }"
                >
                  <a-input v-model:value="localForm.desc" />
                </a-form-item>
              </a-col>
              <a-col :span="10">
                <a-form-item
                  label="CFD_BB_TCM"
                  name="cfdTicker"
                  :labelCol="{ span: 5, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 19 }"
                >
                  <a-input
                    v-model:value="localForm.cfdTicker"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Prime Broker"
                  name="custodianCode"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.custodianCode"
                    placeholder="Select custodian"
                    style="width: 100%"
                    show-search
                    allow-clear
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in custodianList"
                      :key="item.custodianCode"
                      :value="item.custodianCode"
                    >
                      {{ item.custodianCode }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Account"
                  name="custodianAccountCode"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.custodianAccountCode"
                    placeholder="Select custodian"
                    style="width: 100%"
                    show-search
                    allow-clear
                    :filter-option="filterOption"
                    @change="handleChangeCustodianAccount"
                  >
                    <a-select-option
                      v-for="item in custodianAccountOptions"
                      :key="item.accountCode"
                      :value="item.accountCode"
                    >
                      {{ item.accountCode }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Maturity Date"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-date-picker
                    v-model:value="localForm.maturityDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Sec Type"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <SecTypeInput v-model:value="localForm.securityType" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="PnL Ccy"
                  name="pnlCurrency"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.pnlCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Price Divisor"
                  name="priceDivisor"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input-number
                    v-model:value="localForm.priceDivisor"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Price Multiplier"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number
                    v-model:value="localForm.priceMultiplier"
                    style="width: 100%"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Price Basis"
                  name="cleanDirtyPriced"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.cleanDirtyPriced"
                    style="width: 100%"
                  >
                    <a-select-option value="C">Clean Price</a-select-option>
                    <a-select-option value="D">Dirty Price</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item
                  label="SecurityId"
                  v-if="isEdit"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input
                    v-model:value="localForm.securityId"
                    style="width: 100%"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="ExternalSecurityId"
                  v-if="isEdit"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input
                    v-model:value="localForm.externalSecurityId"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="FAS 157 valuation"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="FTT Eligible"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select style="width: 100%" disabled>
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item
                  label="Fixed/Variable"
                  name="fixedFloat"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.fixedFloat"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    :disabled="isEdit"
                  >
                    <a-select-option
                      v-for="item in fixedVariableList"
                      :key="item.key"
                      :value="item.value"
                    >
                      {{ item.key }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Day Count Basis"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option
                      v-for="item in ACCRUALTYPE_LIST"
                      :key="item.key"
                      :value="item.value"
                    >
                      {{ item.key }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>

        <a-row :gutter="24">
          <a-card class="swap-card" title="Swap Details" :bordered="false">
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item
                  label="Financing Methodology"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-select allow-clear disabled> </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Financing Basis"
                  name="financingBasis"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.financingBasis"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in FINANCING_BASIS_LIST"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Generate RLPL Actl Cash-Flow on Trade Date"
                  :labelCol="{ span: 20, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 4 }"
                >
                  <a-checkbox disabled />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Swap Type"
                  name="swapType"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.swapType"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in swapTypeList"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Calendar Roll Ctry"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.calendarRollCountry"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option
                      v-for="item in countryList"
                      :key="item.countryDesc"
                      :value="item.countryCode"
                    >
                      {{ item.countryDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Realise PnL At"
                  name="realisePLTiming"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.realisePLTiming"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in REALISE_PL_TIMING_LIST"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Dividends Paid At"
                  name="dividendPaymentTiming"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.dividendPaymentTiming"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in DIVIDEND_PAYMENT_TIMING_LIST"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Account For Dividends From"
                  :labelCol="{ span: 14, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 10 }"
                >
                  <a-select
                    v-model:value="localForm.accountForDividendsFrom"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in accountForDividendsFromList"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Dividend %"
                  name="underlyingDividendPercent"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number
                    v-model:value="localForm.underlyingDividendPercent"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Dividend Ccy"
                  name="dividendCurrency"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.dividendCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Dividend/PnL Ccy Xrate"
                  name="fixedRate"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-row>
                    <a-col :span="12">
                      <a-input-number
                        v-model:value="localForm.fixedRate"
                        style="width: 100%"
                      />
                    </a-col>
                    <a-col :span="12">
                      <a-select
                        style="width: 100%"
                        v-model:value="localForm.fixedRateMdInd"
                      >
                        <a-select-option :value="M">M</a-select-option>
                        <a-select-option :value="D">D</a-select-option>
                      </a-select>
                    </a-col>
                  </a-row>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item
                  label="Update when Rule is Updated"
                  :labelCol="{ span: 14, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 10 }"
                >
                  <a-checkbox disabled />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, inject, watch } from 'vue'
import { useStore } from 'vuex'
import SecTypeInput from '@/components/SecTypeInput.vue'
import debounce from 'lodash/debounce'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
import {
  ACCRUALTYPE_LIST,
  FINANCING_BASIS_LIST,
  DIVIDEND_PAYMENT_TIMING_LIST,
  REALISE_PL_TIMING_LIST,
} from '@/utils/secutils'

const store = useStore()

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  addForm: {
    type: Object,
    required: true,
  },
})

const labelCol = { span: 6, style: { textAlign: 'left' } }
const wrapperCol = { span: 18 }

const exchangeList = inject('exchangeList', ref([]))
const issuerList = inject('issuerList', ref([]))
const swapInstClassList = inject('swapInstClassList', ref([]))
const custodianList = inject('custodianList', ref([]))
const custodianAccountList = inject('custodianAccountList', ref([]))
const security = inject('security')

const addFormRef = ref(null)
const loading = ref(false)
const localForm = ref(props.addForm)

// set only when the user picks an issuer from the dropdown, so the currency
// defaults below never overwrite values loaded from getSecurity
const isIssuerSelectedByUser = ref(false)
const onIssuerChange = () => {
  isIssuerSelectedByUser.value = true
}
const rules = {
  instrumentClass: [
    { required: true, message: 'Please input instrumentClass' },
  ],
  desc: [{ required: true, message: 'Please input name' }],
  cfdTicker: [{ required: true, message: 'Please input CFD_BB_TCM' }],
  issuer: [{ required: true, message: 'Please select issuer' }],
  issuePrice: [{ required: true, message: 'Please input issue price' }],
  pnlCurrency: [{ required: true, message: 'Please select PnL ccy' }],
  exchange: [{ required: true, message: 'Please select exchange' }],
  custodianCode: [{ required: true, message: 'Please select prime broker' }],
  custodianAccountCode: [{ required: true, message: 'Please select account' }],
  priceDivisor: [{ required: true, message: 'Please input price divisor' }],
  cleanDirtyPriced: [
    { required: true, message: 'Please select price basis', trigger: 'blur' },
  ],
  fixedFloat: [{ required: true, message: 'Please input Fixed/Variable' }],
  financingBasis: [
    { required: true, message: 'Please select financing basis' },
  ],
  swapType: [{ required: true, message: 'Please input swap type' }],
  realisePLTiming: [
    { required: true, message: 'Please select Realise PnL At' },
  ],
  dividendPaymentTiming: [
    { required: true, message: 'Please select Dividend Paid At' },
  ],
  underlyingDividendPercent: [
    {
      required: true,
      message: 'Please input dividend %',
    },
  ],
  dividendCurrency: [{ required: true, message: 'Please select dividend ccy' }],
  fixedRate: [
    { required: true, message: 'Please input Dividend/PnL Ccy Xrate' },
  ],
  underlyingTicker: [
    {
      required: true,
      message: 'Please select underlying',
    },
  ],
}

const countryList = computed(() => {
  const countries = store.getters['reference/getCountryList'] || []
  return [...countries].sort((a, b) =>
    a.countryCode.localeCompare(b.countryCode)
  )
})

const currencyList = computed(() => {
  const currencies = store.getters['reference/getCurrencyList'] || []
  return [...currencies].sort((a, b) =>
    a.currencyCode.localeCompare(b.currencyCode)
  )
})

const countryCurrencyList = computed(() => {
  return store.getters['reference/getCountryCurrencyList'] || []
})

const emit = defineEmits(['update:visible', 'update:security'])

const modalVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val),
})

const userName = computed(() => store.getters['auth/getUserName'] || 'Guest')

const swapTypeList = ref(['CASH', 'NOTIONAL'])
const fixedVariableList = ref([
  { key: 'Fixed', value: 'F' },
  { key: 'Variable', value: 'V' },
])

const accountForDividendsFromList = ref(['SCEV_DATE', 'SCEV_PAY_DATE'])

const underlyingOptions = ref([])
const tickerList = ref([])
const custodianAccountOptions = ref([])

watch(
  () => localForm.value.custodianCode,
  (val) => {
    localForm.value.custodianCode = val
    // localForm.value.custodianAccountCode = null
    custodianAccountOptions.value = custodianAccountList.value.filter(
      (item) => item.custodianCode === val
    )
  },
  {
    immediate: true,
  }
)
const handleChangeCustodianAccount = (val) => {
  localForm.value.fundCode = custodianAccountOptions.value.find(
    (ca) => ca.accountCode === val
  )?.fundCode
}

const onSelectUnderlying = async (value) => {
  localForm.value.underlyingTicker = value
  const res = await security.getSecurityStartWith({ ticker: value })
  const underlying = res.data?.[0]
  if (!underlying) {
    return
  }
  underlying.pnlCurrency = underlying.pnlCcyCode
  const selectedUnderlyingExchange = exchangeList.value.find(
    (item) => item.exchName === underlying.exchangeCode
  )
  if (selectedUnderlyingExchange) {
    underlying.exchange = {
      exchangeId: selectedUnderlyingExchange.exchangeId,
      exchName: selectedUnderlyingExchange.exchName,
    }
  }
  const selectedUnderlyingIssuer = issuerList.value.find(
    (item) => item.name === underlying.issuerCode
  )
  if (selectedUnderlyingIssuer) {
    underlying.issuer = {
      issuerId: selectedUnderlyingIssuer.issuerId,
      externalIssuerId: selectedUnderlyingIssuer.externalIssuerId,
      name: selectedUnderlyingIssuer.name,
      countryOfDomicile: selectedUnderlyingIssuer.countryOfDomicile,
    }

    const selectedCurrency = countryCurrencyList.value.find(
      (item) => item.countryCode === underlying.issuer.countryOfDomicile
    )
    if (selectedCurrency) {
      underlying.issuer.issueCurrency = selectedCurrency.currencyCode
    }
  }
  localForm.value.underlying = underlying
}

watch(
  () => props.addForm,
  (newVal) => {
    isIssuerSelectedByUser.value = false
    if (props.visible) {
      localForm.value = newVal
      if (props.isEdit && localForm.value.underlyingTicker) {
        onSelectUnderlying(localForm.value.underlyingTicker)
      }
      if (!newVal.underlying) {
        localForm.value.underlying = {
          exchange: {
            exchangeId: null,
            exchName: null,
            micExchName: null,
          },
        }
      } else if (!newVal.underlying.exchange) {
        localForm.value.underlying = {
          ...newVal.underlying,
          exchange: {
            exchangeId: null,
            exchName: null,
            micExchName: null,
          },
        }
      }
    }
  },
  {
    immediate: true,
  }
)
watch(
  () => localForm.value.priceDivisor,
  (newValue) => {
    if (newValue && props.visible) {
      localForm.value.priceDivisor = newValue
      localForm.value.priceMultiplier = 1 / newValue
    }
  },
  { immediate: true }
)

watch(
  () => localForm.value.issuer?.issuerId,
  (newValue) => {
    if (newValue && props.visible) {
      const selectedIssuer = issuerList.value.find(
        (item) => item.issuerId === newValue
      )
      if (selectedIssuer) {
        localForm.value.issuer = {
          issuerId: selectedIssuer.issuerId,
          externalIssuerId: selectedIssuer.externalIssuerId,
          name: selectedIssuer.name,
          countryOfDomicile: selectedIssuer.countryOfDomicile,
        }
        const selectedCurrency = countryCurrencyList.value.find(
          (item) => item.countryCode === selectedIssuer.countryOfDomicile
        )
        if (selectedCurrency && isIssuerSelectedByUser.value) {
          localForm.value.issueCurrency = selectedCurrency.currencyCode
          localForm.value.pnlCurrency = selectedCurrency.currencyCode
          localForm.value.dividendCurrency = selectedCurrency.currencyCode
        }
      }
    }
  },
  { immediate: true }
)

const filterOption = (input, option) => {
  const key = option?.key ?? option?.value ?? ''
  return String(key).toLowerCase().includes(input.toLowerCase())
}

const searchUnderlying = (ticker) => {
  if (!ticker || ticker.length < 3) {
    return
  }
  security.getSecurityStartWith({ ticker }).then((res) => {
    const data = Array.isArray(res.data) ? res.data : []
    tickerList.value = data
    const underlyingTickers = data
      .filter((item) => item.ticker)
      .map((item) => item.ticker)
    underlyingTickers.sort((a, b) => b.localeCompare(a))
    const arr =
      underlyingTickers.length > 8
        ? underlyingTickers.slice(0, 8)
        : underlyingTickers
    underlyingOptions.value = arr.map((item) => ({ value: item }))
  })
}
const onSearchUnderlying = debounce(
  function (underlyingTicker) {
    searchUnderlying(underlyingTicker)
  },
  600,
  { maxWait: 1000 }
)

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback

const formatDateTime = (val) =>
  val ? dayjs(val).format('YYYY-MM-DDTHH:mm:ss') : null

const buildPayload = () => {
  const payload = {
    ...localForm.value,
    name: localForm.value.desc,
    exchange: { ...localForm.value.exchange },
    issuer: { ...localForm.value.issuer },
    identifiers: [],
    underlying:
      localForm.value.underlyingTicker && localForm.value.underlying
        ? { ...localForm.value.underlying }
        : null,
    issueDate: formatDateTime(localForm.value.issueDate),
    maturityDate: formatDateTime(localForm.value.maturityDate),
    settleDate: formatDateTime(localForm.value.settleDate),
    lastModifiedOn: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
    lastModifiedBy: userName.value,
  }

  if (payload.cfdTicker) {
    payload.identifiers.push({
      type: '_CFD_BB_TCM',
      value: payload.cfdTicker,
    })
  }

  const selectedExchange = exchangeList.value.find(
    (item) => item.exchangeId === payload.exchange.exchangeId
  )
  if (selectedExchange) {
    payload.exchange = {
      exchangeId: selectedExchange.exchangeId,
      exchName: selectedExchange.exchName,
      micExchName: selectedExchange.micExchName,
    }
  }

  if (payload.underlyingTicker) {
    const underlyingIdentifiers = [
      {
        type: 'BB_TCM',
        value: payload.underlyingTicker,
        securityId: payload.underlying?.securityId,
        pnlCurrency: payload.underlying?.pnlCurrency,
      },
    ]
    if (!payload.underlying) payload.underlying = {}
    payload.underlying.identifiers = underlyingIdentifiers
    payload.underlying.instrumentClass = payload.underlying.instrumentClass
      ? 'DUMMY'
      : payload.underlying.instrumentClass
  }

  return payload
}

const handleOk = async () => {
  try {
    await addFormRef.value?.validate()
  } catch (error) {
    message.warning(getErrorMessage(error, 'Please complete required fields'))
    return
  }

  loading.value = true
  try {
    const payload = buildPayload()
    if (props.isEdit) {
      await security.updateSec(payload)
      message.success('Security updated successfully')
    } else {
      await security.createSec(payload)
      message.success('Security created successfully')
    }
    modalVisible.value = false
  } catch (error) {
    message.error(
      getErrorMessage(
        error,
        props.isEdit ? 'Failed to update security' : 'Failed to create security'
      )
    )
  } finally {
    loading.value = false
  }
}

const handleCancel = () => {
  modalVisible.value = false
}
</script>

<style scoped>
.swap-card {
  width: 100%;
  margin-bottom: 12px;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
}
.swap-card :deep(.ant-card-head-title) {
  font-weight: 600;
  letter-spacing: 0.2px;
}
.swap-card :deep(.ant-card-body) {
  padding-top: 8px;
}
</style>
